<div class="modal-log-conteiner">
  <div class="dropdown-box">
    <app-dropdown-button [isOpen]="historyFilterOpen"
    (valueChange)="historyFilterOpen = $event"
    [label]="historyFilter.value"
    [alignRight]=true>
      <ul class="dropdown-text-list">
        <div id="fac-history-filter-{{i}}" *ngFor="let item of combosList; let i = index">
          <li (click)="setFilter(item)">
            {{item.value}}                  
          </li>
        </div>           
      </ul>
    </app-dropdown-button>
  </div>

  <app-fac-history-chat [facHistory]="historyListFilter"></app-fac-history-chat>

  <div class="empty-log" *ngIf="!loading && historyListFilter.length === 0">
    <span>Não existe logs </span>
    <span [ngSwitch]="historyFilter.type">
      <span *ngSwitchCase="'contacts'">de contato</span>
      <span *ngSwitchCase="'registration_data'">de dados cadastrais</span>
      <span *ngSwitchCase="'others'">de outros</span>
      <span *ngSwitchCase="'all'">para essa fac</span>      
    </span>
  </div>
</div>